<span class="trademark">
  {{ trademark }}
</span>

<div id="actions">
  @if (activeTab === 'active') {
  <app-update-order [order]="params.data"></app-update-order>
  }
  <app-export
    [disabled]="false"
    [rowId]="orderId"
    [trademarkName]="trademark"
    [tooltipPosition]="'below'"
  ></app-export>
  @if (activeTab === 'active') {
  <app-cancel-order
    [trademarkName]="trademark"
    [orderId]="orderId"
    [cancelDate]="cancelDate"
  ></app-cancel-order>
  } @if (linkedFullTextCount > 0) {
  <app-freetext-icon
    [order]="params.data"
    [disabled]="params.data.pendingUpdateDate"
    [linkedFullTextCount]="linkedFullTextCount"
  ></app-freetext-icon>
  } @if (isSharingEnabled && activeTab === 'active') {
  <app-share-order
    [sharedRecipientDetails]="params.data.sharedRecipientDetailsList"
    [params]="params"
  ></app-share-order>
  }
</div>
